export default "__VITE_ASSET__Dke7aWLJ__"